var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsEnum, IsNumber, IsString, IsUUID } from 'class-validator';
import { PreventionSectionType } from '../enum/prevention-section-type.js';
import { UpdatePreventionChapterMarkerDto } from './update-prevention-chapter-marker.dto.js';
import { UpdatePreventionQuizQuestionDto } from './update-prevention-quiz-question.dto.js';
export class UpdatePreventionCourseModuleSectionDto {
    id;
    title;
    sectionName;
    description;
    deviceText;
    preventionSectionType;
    preventionChapterMarkers;
    preventionChapterQuizQuestions;
    videoId;
    loopVideoId;
    duration;
    readingDuration;
    repititionCount;
    repititionDuration;
    pauseDuration;
    videoModalTitle;
    videoModalText;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleSectionDto.prototype, "id", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleSectionDto.prototype, "title", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleSectionDto.prototype, "sectionName", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleSectionDto.prototype, "description", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UpdatePreventionCourseModuleSectionDto.prototype, "deviceText", void 0);
__decorate([
    IsEnum(PreventionSectionType),
    Expose(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleSectionDto.prototype, "preventionSectionType", void 0);
__decorate([
    IsArray(),
    Type(() => UpdatePreventionChapterMarkerDto),
    Expose(),
    __metadata("design:type", Array)
], UpdatePreventionCourseModuleSectionDto.prototype, "preventionChapterMarkers", void 0);
__decorate([
    IsArray(),
    Type(() => UpdatePreventionQuizQuestionDto),
    Expose(),
    __metadata("design:type", Array)
], UpdatePreventionCourseModuleSectionDto.prototype, "preventionChapterQuizQuestions", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UpdatePreventionCourseModuleSectionDto.prototype, "videoId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UpdatePreventionCourseModuleSectionDto.prototype, "loopVideoId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdatePreventionCourseModuleSectionDto.prototype, "duration", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdatePreventionCourseModuleSectionDto.prototype, "readingDuration", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdatePreventionCourseModuleSectionDto.prototype, "repititionCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdatePreventionCourseModuleSectionDto.prototype, "repititionDuration", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdatePreventionCourseModuleSectionDto.prototype, "pauseDuration", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleSectionDto.prototype, "videoModalTitle", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleSectionDto.prototype, "videoModalText", void 0);
//# sourceMappingURL=update-prevention-course-module-section.dto.js.map